import { useParams } from "react-router-dom";
import { TemplateViewr } from "./TemplateViewr";


export const DesignPreview = () => {
  const { template_id } = useParams();

  return (
    <TemplateViewr template_id={template_id} />
  )
}
